/*
 * @Description 组件  VideoPlay 视频播放
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div :class="{'table-item-box': true, 'max-box': !showBoxFlag}">
		<section style="height: 100%; width: 100%;">
			
			<!--查询工具条-->
			<el-col style="text-align: left;padding: 0;">
				<el-form :inline="true" :model="filters" ref="filters">
					<el-form-item class="grad-btns-item" style="position: absolute;top: -60px;right: 20px;margin: 0px;z-index: 3;">
						<el-button :class="{'on': gridFilters.grid == 1}" icon="iconfont el-icon-my_yuanjiao-rect" type="primary" size="mini" trigger="click" @click="changeGrid(1)" title="1宫格"></el-button>
						<el-button :class="{'on': gridFilters.grid == 4}" icon="iconfont el-icon-my_dasuolvetuliebiao" type="primary" size="mini" trigger="click" @click="changeGrid(4)" title="4宫格"></el-button>
						<el-button :class="{'on': gridFilters.grid == 9}" icon="iconfont el-icon-my_xiaosuolvetu" type="primary" size="mini" trigger="click" @click="changeGrid(9)" title="9宫格"></el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<!--查询工具条-->
			
			<!-- view-page-grid start -->
			<div class="view-page-grid">
				
				<!-- 翻页 按钮 start -->
				<el-button type="primary" icon="el-icon-arrow-left" class="btn-turn-page btn-turn-pre" circle :disabled="pagination.currentPage <= 1" title="上一页" @click="changePage('pre')"></el-button>
				<el-button type="primary" icon="el-icon-arrow-right" class="btn-turn-page btn-turn-next" circle :disabled="pagination.currentPage >= pagination.wholePage" title="下一页" @click="changePage('next')"></el-button>
				<!-- 翻页 按钮 end -->
				
				<!-- 宫格 start  -->
				<div class="grid-contain-box">
					<!-- 行 start -->
					<div v-for="i in gridFilters.rowNum" :key="i" :class="'grid-contain-row col-items-'+(gridFilters.rowNum <=3 ? gridFilters.rowNum : 3)">
						<!-- 列 start -->
						<div v-for="j in gridFilters.colNum" :key="[i, j].join('_')" :class="'grid-contain-col row-items-'+(gridFilters.colNum <= 3 ? gridFilters.colNum : 3)">
							<!-- 内容 start -->
							<div :class="{'grid-contain-item cursor-pointer': true, 'grid-item-title-has': checkRowItem(gridFilters.colNum*(i-1)+j-1, dataList), 'on': (checkedIndexs.indexOf(gridFilters.colNum*(i-1)+j-1) != -1)}" @click="toggleItem(gridFilters.colNum*(i-1)+j-1)">
								<span v-if="checkRowItem(gridFilters.colNum*(i-1)+j-1, dataList)" class="grid-contain-item-title text-over" v-html="extractRowItem(gridFilters.colNum*(i-1)+j-1, dataList)" :title="extractRowItemTitle(gridFilters.colNum*(i-1)+j-1, dataList)"></span>
								<!--<SubVideo :vEleId="['vId', i, j].join('_')" :vInfo="dataList[gridFilters.colNum*(i-1)+j-1]" />-->
								<SubVideoRTSP :vEleId="['vId', i, j].join('_')" :vInfo="dataList[gridFilters.colNum*(i-1)+j-1]" :controls="true" />
							</div>
							<!-- 内容 end -->
						</div>
						<!-- 列 end -->
					</div>
					<!-- 行 end -->
				</div>
				<!-- 宫格 end  -->
				
			</div>
			<!-- view-page-grid end -->
			
		</section>
	</div>
</template>

/* JS */
<script>
	// API 视频接口
    import ApiVideo from '@/request/api-video';
	// 组件 播放视频
	//import SubVideo from '@/components/SubVideo/SubVideo';
	// 组件 播放视频 RTSP
	import SubVideoRTSP from '@/components/SubVideo/SubVideoRTSP';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "VideoPlayGrids",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 播放视频
			//SubVideo,
			// 组件 播放视频 RTSP
			SubVideoRTSP,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
		props: {
			/**
			 * @Des 展示box
			 * @Auth
			 * @Date
			 */
			showBoxFlag: {
				type: Boolean,
				default: function (){
					return true
				}
			},// showBoxFlag
			
			/**
			 * @Des 宫格属性
			 * @Auth
			 * @Date
			 */
			gridFilters: {
				type: Object,
				default: function (){
					return {
						grid: 1,// 宫格
						rowNum: 1,// 行
						colNum: 1,// 列
					};
				}
			},// gridFilters
			
			/**
			 * @Des 分页组件
			 * @Auth
			 * @Date
			 */
			pagination: {
				type: Object,
				default: function (){
					return { total: 0, startNum: 0, limit: 1, currentPage: 1, wholePage: 1 };
				}
			},// pagination
			
			// 选中 下标
			checkedIndexs: {
				type: Array,
				default: function (){
					return [];
				}
			},// checkedIndexs
			
			// 展示数据
			dataList: {
				type: Array,
				default: function (){
					return [];
				}
			},// dataList
			
		},// props
		
		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				
				/**
				 * @Des 查询条件属性
				 * @Auth
				 * @Date
				 */
				filters: {
					readModes: [{
						id: 1,
						name: '硬盘录像机'
					},{
						id: 2,
						name: '摄像头'
					}],
					brands: [{
						id: 1,
						name: '海康'
					},{
						id: 2,
						name: '宇视'
					},{
						id: 3,
						name: '大华'
					}],
					subtypes: [{
						id: 1,
						name: '主码流'
					},{
						id: 2,
						name: '子码流'
					}],
					codecs: [{
						id: 1,
						name: 'H.264'
					},{
						id: 2,
						name: 'H.265'
					}],
				},// filters
				
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 点击 单元格
			 * @Auth
			 * @Date
			 */
			toggleItem(index) {
				this.$emit('toggleItem', index);
			},// toggleItem
			
			/**
			 * @Des 点击 宫格 按钮
			 * @Auth
			 * @Date
			 */
			changeGrid(val) {
				this.$emit('changeGrid', val);
			},// changeGrid
			
			/**
			 * @Des 翻页
			 * @Auth
			 * @Date
			 */
			changePage(val) {
				this.$emit('changePage', val);
			},// changePage
			
			/**
			 * @Des 检索row 数据
			 * @Auth
			 * @Date
			 */
			checkRowItem(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return false;
				
				return !this.$checkEmpty(rows[index]) && !this.$checkEmpty(rows[index].diskChannelName);
			},// checkRowItem
			
			/**
			 * @Des 提取row 数据
			 * @Auth
			 * @Date
			 */
			extractRowItem(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return '';
				// 空值 中止
				if (this.$checkEmpty(rows[index])) return '';
				
				// 名称
				let diskChannelName = !this.$checkEmpty(rows[index].diskChannelName) ? rows[index].diskChannelName : '';
				// 编号
				let _number = !this.$checkEmpty(rows[index].number) ? rows[index].number : '';
				return [diskChannelName, (!this.$checkEmpty(_number) ? ('（'+ _number +'）') : '')].join('');
			},// extractRowItem
			/**
			 * @Des 提取row 数据 title
			 * @Auth
			 * @Date
			 */
			extractRowItemTitle(index, rows=[]) {
				// 空值 中止
				if (this.$checkEmpty(index)) return '';
				let row = Object.assign({}, rows[index]);
				// 空值 中止
				if (this.$checkEmpty(row)) return '';
				
				let list = [];
				
				// 视频名称
				list.push(['视频名称', (row.diskChannelName ? row.diskChannelName : '----')].join('：'));
				
				// 视频编号
				list.push(['视频编号', (row.number ? row.number : '----')].join('：'));
				
				// IP
				list.push(['IP', (row.diskIp ? row.diskIp : row.cameraIp ? row.cameraIp : '----')].join('：'));
				
				// 码流类型
				let subtypeName = this.matchRowsByKey(this.filters.subtypes, 'id', row.subtype).name;
				list.push(['码流类型', (!this.$checkEmpty(subtypeName) ? subtypeName : '----')].join('：'));
				
				// 编码格式
				let codecName = this.matchRowsByKey(this.filters.codecs, 'id', row.codec).name;
				list.push(['编码格式', (!this.$checkEmpty(codecName) ? codecName : '----')].join('：'));
				
				// 读取类型
				let readModeName = this.matchRowsByKey(this.filters.readModes, 'id', row.readMode).name;
				list.push(['读取类型', (!this.$checkEmpty(readModeName) ? readModeName : '----')].join('：'));
				
				// 通道号
				list.push(['通道号', (row.diskChannelNo ? row.diskChannelNo : '----')].join('：'));
				
				// 账号
				list.push(['账号', (row.diskAccount ? row.diskAccount : row.cameraAccount ? row.cameraAccount : '----')].join('：'));
				
				// 是否启用
				list.push(['是否启用', (row.isOpen == 1 ? '已启用' : '未启用')].join('：'));
				
				// 摄像头厂家
				let brandName = this.matchRowsByKey(this.filters.brands, 'id', row.brand).name;
				list.push(['摄像头厂家', (!this.$checkEmpty(brandName) ? brandName : '----')].join('：'));
				
				return Object.assign([], list).join('\n');
			},// extractRowItemTitle
			
			/**
			 * @Des 数据匹配
			 * @Auth
			 * @Date
			 */
			matchRowsByKey(rows, key, val){
				let obj = {};
				let keys = Object.keys(rows);
				keys.forEach((_key, index) => {
					let row = Object.assign({}, rows[_key]);
					if (row[key] == val) {
						obj = Object.assign({}, row);
					}
				});
				return obj;
			},// matchRowsByKey
            
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Video/VideoPlayGrids.vue